import { matchRoutes } from 'react-router-dom';

export type ReportsTab = 'rides' | 'riders' | 'report_history';

const reportsTabRoutes: { path: string; tab: ReportsTab }[] = [
  { path: '/reports/riders', tab: 'riders' },
  { path: '/reports/history', tab: 'report_history' },
];

export const getCurrentTab = (pathname: string): ReportsTab =>
  matchRoutes(reportsTabRoutes, pathname)?.[0].route.tab ?? 'rides';
